<div tiimeLargeProperty>{{ title }}</div>
<div tiimeProperty>
  <span class="italic break-word" tiimeFallbackText>
    {{ permanentNote }}
  </span>
</div>
